import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { Utility } from './../../Common/Services/utility';
import { Router } from '@angular/router';

@Directive({
    selector: '[menu-navigation]'
})
export class MenuNavigationDirective {
    @Input('menu-navigation') data: any;
    isSameMenuClicked: boolean = false;
    constructor(private elRef: ElementRef, private _utility: Utility, private _router: Router) {
    }

    @HostListener('click', ['$event'])
    handleMenuItemClick(event: Event) {
        let menuItem, txnStatus;
        if (this.data) {
            menuItem = this.data.menuData;
            txnStatus = this.data.txnStatus;
            this.hideSubMenu(event);
            if (!menuItem || menuItem.redirectTo == null || menuItem.redirectTo == '') {
                this.showSubMenu(event);
                return;
            }
        }
        try {
            let parent = this.elRef.nativeElement.offsetParent; //menu-list element
            if (parent) {
                // hightlight menu element by adding active class
                // remove active class when click on other menu item
                let activeClsElement = parent.getElementsByClassName('active');
                if (activeClsElement.length > 0) {
                    activeClsElement[0].classList.remove('active');
                }
            }
            let clsList = this.elRef.nativeElement.parentElement.classList;
            if (clsList.contains('submenu-item')) {
                let parentNode = this.elRef.nativeElement.parentNode.parentNode.parentNode;
                if (parentNode) {
                    parentNode.classList.add('active');
                }
            } else {
                this.elRef.nativeElement.classList.add('active');
            }


            //Show, hide menu navigation area by adding , remvoing active class
            let showMenu = document.getElementById('hdr_sec').classList;
            if (showMenu.contains('active')) {
                showMenu.remove('active');
            }
            else {
                showMenu.add("active");
                event.stopPropagation();
            }

        } catch (e) {
            console.error('some issue with menu navigation directive');
        }

        // display unsaved changes box if txtStatus value is true
        if (txnStatus == true) {
            this._utility.showUnsavedChangesConfirmBox(function () {
                this._utility.clearTxnStatus();
                this.redirectToPage(menuItem);
            }.bind(this));
        } else {
            this.redirectToPage(menuItem);
        }
    }

    // When Clicking on rest of page
    @HostListener('document:click', ['$event'])
    handleClick(event: Event) {

        if (((<any>event.target).parentElement && (<any>event.target).parentElement.id == 'hdr_sec') || (<any>event.target).tagName == 'HEADER') {
            return;
        }
        this.hideSubMenu(event);
        // display unsaved changes box if txtStatus value is true
        let showMenu = document.getElementById('hdr_sec').classList;
        if (showMenu.contains('active')) {
            //(<any>showMenu).replace('active', 'inactive');
            showMenu.remove('active');
        }
    }

    /**
     * Add subMenuSec-show class
     * create sub menus div heights dyanamically and add this in style because from css animation does not work on height : auto property.
     */
    private showSubMenu(event : Event) {
        let subMenus = this.elRef.nativeElement.lastElementChild;
        let subMenuItemCount = subMenus.children.length;
        let height = subMenuItemCount * 35 + 'px';
        if (!this.isSameMenuClicked) {
            subMenus.classList.add('subMenuSec-show');
            subMenus.style.height = height;
        }

        event.stopPropagation(); // when sub menus displayed , stop event.
    }

    private hideSubMenu(event : Event) {
        this.isSameMenuClicked = false;
        let parent = this.elRef.nativeElement.offsetParent; //menu-list element
        if (parent) {
            // hide other sub menus if they are open
            let visibleSubMenuElement = parent.getElementsByClassName('subMenuSec-show');
            if (visibleSubMenuElement.length > 0) {
                let htmlMenuText = visibleSubMenuElement[0].parentElement.innerText;

                if (this.data) {
                    let data = this.data.menuData;
                    // if below IF condition is true, it means menu on which we have just clicked and menu which is being just hidden are same
                    if (htmlMenuText.indexOf(data && data.groupText ? data.groupText : data.text) > -1) {
                        this.isSameMenuClicked = true;
                    }
                }
                visibleSubMenuElement[0].style.height = 0;
                visibleSubMenuElement[0].classList.remove('subMenuSec-show');
                event.stopPropagation();

            }
        }
    }

    // navigate user to selected menu's page
    private redirectToPage(menuItem: any) {
        if (menuItem && menuItem.redirectTo) {
          let url = menuItem.redirectTo;
          // if it is a external url, do not use the internal router:
          if (url.startsWith("http") || url.startsWith('//')) {
            document.location.href = menuItem.redirectTo;
            return;
          }
          this._router.navigate([url]);
        }
    }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Directives/menu-navigation.directive.ts